import { Modal } from "react-bootstrap";
import ReactDOM from "react-dom";
import i18n from "./languages/INEXT";
import { Box, ButtonStyled, SpanStyled } from "./components/styled/Elements";
import * as XLSX from "xlsx";

export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const phoneRegex = /^(?:966|0)?5\d{8}$/;
// export const phoneRegex = /^(009665|9665|\+9665|05|5)([503649187])([0-9]{7})$/;

export const getAccessToken = () => {
  const storedToken = localStorage.getItem("access_token");
  const accessToken = JSON.parse(storedToken);
  return accessToken;
};

export const getUserObj = () => {
  const storedUser = localStorage.getItem("userInfo");
  const userToken = JSON.parse(storedUser);
  return userToken;
};
export const getFeaturesObj = () => {
  const storedFeatures = localStorage.getItem("all_features");
  const features = JSON.parse(storedFeatures);
  return features;
};
export const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
export const getFormattedDate = (isoDate) => {
  const date = new Date(isoDate);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear().toString().slice(-2);
  return `${month}/${day}/${year}`;
};
export const reqFormatDate = (isoDate) => {
  const date = new Date(isoDate);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear().toString().slice(-2);
  return `${year}-${month}-${day}`;
};

export const getFormattedTime = (isoDate) => {
  const date = new Date(isoDate);
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${hours}:${minutes} ${ampm}`;
};
export const getFormattedTimeWithSec = (isoDate) => {
  const date = new Date(isoDate);
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${hours}:${minutes}:${seconds} ${ampm}`;
};
export const formatedRemainingTime = (seconds) => {
  if (seconds < 60) {
    return `${Math.ceil(seconds)} sec${seconds > 1 ? "s" : ""}`;
  } else if (seconds < 3600) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.ceil(seconds % 60);
    return `${minutes} min${minutes > 1 ? "s" : ""} ${remainingSeconds} sec${
      remainingSeconds > 1 ? "s" : ""
    }`;
  } else {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return `${hours} hr${hours > 1 ? "s" : ""} ${minutes} min${
      minutes > 1 ? "s" : ""
    }`;
  }
};
export const formateAmounts = (num) => {
  var parsedNum = parseFloat(num);
  var formattedNum = parsedNum.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formattedNum ? formattedNum : 0;
};

export const formatTimeToFull = (dateObj) => {
  if (!(dateObj instanceof Date) || isNaN(dateObj)) return "00:00:00";

  const pad = (val) => String(val).padStart(2, "0");
  const hours = pad(dateObj.getHours());
  const minutes = pad(dateObj.getMinutes());
  const seconds = pad(dateObj.getSeconds());

  return `${hours}:${minutes}:${seconds}`;
};

export const checkPermission = (moduleId, actionId, featureId = null) => {
  const userObj = getUserObj();
  const permissions = userObj?.permissions;
  const userType = Number(userObj?.user_type_id);
  const allowedFeatures =
    userObj?.current_organization?.plan_detail?.plan?.allowed_features || [];

  if (featureId) {
    const hasFeature = allowedFeatures.some(
      (f) => parseInt(f?.id) === parseInt(featureId)
    );
    if (!hasFeature) {
      return false; // Plan does not allow this feature
    }
  }
  if (
    userType === 2 ||
    userType === 3 ||
    userObj?.is_temporary_admin_director
  ) {
    return true;
  }
  if (
    userType === 6 &&
    (moduleId === 1 || moduleId === 2 || moduleId === 3) &&
    actionId !== 4 &&
    actionId !== 2
  ) {
    return true;
  }
  if (permissions && Array.isArray(permissions) && permissions.length > 0)
    return permissions.some(
      (permission) =>
        permission.permission_type_id === moduleId &&
        permission.permission_operation_id === actionId
    );
  return false;
};

export const getModuleOperations = (typeId, actionId, featureId = null) => {
  const userObj = getUserObj();
  const userType = Number(userObj?.user_type_id);
  const permissions = userObj?.permissions;
  const allowedFeatures =
    userObj?.current_organization?.plan_detail?.plan?.allowed_features || [];

  if (featureId) {
    
    const hasFeature = allowedFeatures.some(
      (f) => parseInt(f?.id) === parseInt(featureId)
    );
    console.log(
      "module feature", featureId, hasFeature
    );
    if (!hasFeature) {
      return false; // Plan does not allow this feature
    }
  }
  if (
    userType === 2 ||
    userType === 3 ||
    userObj?.is_temporary_admin_director
  ) {
    return true;
  }
  if (
    userType === 6 &&
    (typeId === 1 || typeId === 2 || typeId === 3) &&
    actionId !== 4 &&
    actionId !== 2
  ) {
    return true;
  }
  if (permissions && Array.isArray(permissions) && permissions.length > 0) {
    const moduleOperations = permissions
      .filter((permission) => permission.permission_type_id === typeId)
      .map((permission) => permission.permission_operation_id);
    return moduleOperations.includes(actionId);
  }
  return false;
};

export const hasPlanFeature = (featureId) => {
  const userObj = getUserObj();
  const allowedFeatures =
    userObj?.current_organization?.plan_detail?.plan?.allowed_features || [];

  return allowedFeatures.some(
    (f) => parseInt(f?.id, 10) === parseInt(featureId, 10)
  );
};


// export const checkPermission = (moduleId, actionId) => {
//   const userObj = getUserObj();
//   const userType = Number(userObj?.user_type_id);
//   const userPermissions = userObj?.permissions || [];
//   const planPermissions = userObj?.plan_permissions || [];

//   // Super admins / directors have full access
//   if (
//     userType === 2 ||
//     userType === 3 ||
//     userObj?.is_temporary_admin_director
//   ) {
//     return true;
//   }

//   // Special case for user type 6
//   if (
//     userType === 6 &&
//     [1, 2, 3].includes(moduleId) &&
//     ![2, 4].includes(actionId)
//   ) {
//     return true;
//   }

//   // Check both user and plan permissions
//   const hasUserPermission = userPermissions.some(
//     (perm) =>
//       perm.permission_type_id === moduleId &&
//       perm.permission_operation_id === actionId
//   );

//   const hasPlanPermission = planPermissions.some(
//     (perm) =>
//       perm.permission_type_id === moduleId &&
//       perm.permission_operation_id === actionId
//   );

//   return hasUserPermission && hasPlanPermission;
// };

// export const getModuleOperations = (typeId, actionId) => {
//   const userObj = getUserObj();
//   const userType = Number(userObj?.user_type_id);
//   const userPermissions = userObj?.permissions || [];
//   const planPermissions = userObj?.plan_permissions || [];

//   // Super admins / directors have full access
//   if (
//     userType === 2 ||
//     userType === 3 ||
//     userObj?.is_temporary_admin_director
//   ) {
//     return true;
//   }

//   // Special case for user type 6
//   if (
//     userType === 6 &&
//     [1, 2, 3].includes(typeId) &&
//     ![2, 4].includes(actionId)
//   ) {
//     return true;
//   }

//   // Must be allowed by both plan and user
//   const userActions = userPermissions
//     .filter(p => p.permission_type_id === typeId)
//     .map(p => p.permission_operation_id);

//   const planActions = planPermissions
//     .filter(p => p.permission_type_id === typeId)
//     .map(p => p.permission_operation_id);

//   return userActions.includes(actionId) && planActions.includes(actionId);
// };

export const showSessionExpiredModal = () => {
  const modalContainer = document.createElement("div");
  document.body.appendChild(modalContainer);

  const handleSessionReset = () => {
    // localStorage.clear();
    window.location.href = "/login";
  };

  ReactDOM.render(
    <Modal show={true} centered size="sm">
      <Modal.Body className="text-center px-4 pt-4 pb-2">
        <SpanStyled color="var(--text)">
          {i18n.t("session_expired_login_again")}
        </SpanStyled>
        <Box className="d-flex justify-content-center">
          <ButtonStyled
            label={i18n.t("ok")}
            bg={"var(--white)"}
            color={"var(--themeColor)"}
            onClick={handleSessionReset}
          />
        </Box>
      </Modal.Body>
    </Modal>,
    modalContainer
  );
};

// Excel File Import Method

export const readExcelFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

      resolve(jsonData);
    };

    reader.onerror = (error) => reject(error);
    reader.readAsArrayBuffer(file);
  });
};

export function getRemainingParts(endTime) {
  const now = new Date();
  const end = new Date(endTime);

  let diff = end - now;
  if (diff <= 0)
    return { days: "00", hours: "00", minutes: "00", seconds: "00" };

  const days = String(Math.floor(diff / (1000 * 60 * 60 * 24))).padStart(
    2,
    "0"
  );
  diff %= 1000 * 60 * 60 * 24;

  const hours = String(Math.floor(diff / (1000 * 60 * 60))).padStart(2, "0");
  diff %= 1000 * 60 * 60;

  const minutes = String(Math.floor(diff / (1000 * 60))).padStart(2, "0");
  diff %= 1000 * 60;

  const seconds = String(Math.floor(diff / 1000)).padStart(2, "0");

  return { days, hours, minutes, seconds };
}

export const setIsTemporary = (value) => {
  localStorage.setItem("is_temporary", JSON.stringify(value));
};

export const getIsTemporary = () => {
  const item = localStorage.getItem("is_temporary");
  return item ? JSON.parse(item) : 0;
};

export const removeIsTemporary = () => {
  localStorage.removeItem("is_temporary");
};

// ✅ Combine date and time into one UTC ISO string
export function toUTCISOStringFromDateTime(dateObj, timeObj) {
  if (!dateObj || !timeObj) return null;

  const date = new Date(dateObj);
  const time = new Date(timeObj);

  // Apply time to date
  date.setHours(time.getHours());
  date.setMinutes(time.getMinutes());
  date.setSeconds(time.getSeconds());
  return date.toISOString(); // Converts to UTC
}

export const updateReferrals = (newIncomingData, groupName, previousReferrals = []) => {
  const formattedNew = newIncomingData
    .filter((user) => user.shareReferrals === true)
    .map((user) => ({
      unique_id: `${groupName}_${user.id}`,
      user_id: user.id,
      is_share: 1,
      note: user.referralNote || "",
      group: groupName
    }));
  const remainingReferrals = previousReferrals.filter(ref => ref.group !== groupName);
  return [...remainingReferrals, ...formattedNew];
};